'use strict';
import * as $j_java$002elang$002e$002dObject from "./java.lang.-Object.js";
var $p;
/** @constructor */
function $c_Ljava_time_Year$() {
  this.Jg = 0;
  this.Jh = false;
  this.Je = 0;
  this.Jf = false;
}
export { $c_Ljava_time_Year$ as $c_Ljava_time_Year$ };
$p = $c_Ljava_time_Year$.prototype = new $j_java$002elang$002e$002dObject.$h_O();
$p.constructor = $c_Ljava_time_Year$;
/** @constructor */
function $h_Ljava_time_Year$() {
}
export { $h_Ljava_time_Year$ as $h_Ljava_time_Year$ };
$h_Ljava_time_Year$.prototype = $p;
$p.NL = (function() {
  if ((!this.Jh)) {
    this.Jg = (-999999999);
    this.Jh = true;
  }
  return this.Jg;
});
$p.qM = (function() {
  if ((!this.Jf)) {
    this.Je = 999999999;
    this.Jf = true;
  }
  return this.Je;
});
$p.Vq = (function(year_$_lo, year_$_hi) {
  if (((3 & year_$_lo) === 0)) {
    var sign = (year_$_hi >> 31);
    var xlo = (year_$_lo ^ sign);
    var rlo = ((xlo - sign) | 0);
    var rhi = (((year_$_hi ^ sign) + (((rlo >>> 0) < (xlo >>> 0)) | 0)) | 0);
    var k$2 = (((rhi >>> 0) % 100) | 0);
    var quotLo$2 = ((0.010000000000000004 * ((4.294967296E9 * k$2) + (rlo >>> 0.0))) | 0.0);
    var remLo = ((rlo - Math.imul(100, quotLo$2)) | 0);
    if ((year_$_hi < 0)) {
      var lo$1 = ((-remLo) | 0);
      var hi = ((-((lo$1 !== 0) | 0)) | 0);
      var x$1_$_lo = lo$1;
      var x$1_$_hi = hi;
    } else {
      var x$1_$_lo = remLo;
      var x$1_$_hi = 0;
    }
    if (((x$1_$_lo | x$1_$_hi) !== 0)) {
      return true;
    } else {
      var sign$1 = (year_$_hi >> 31);
      var xlo$1 = (year_$_lo ^ sign$1);
      var rlo$1 = ((xlo$1 - sign$1) | 0);
      var rhi$1 = (((year_$_hi ^ sign$1) + (((rlo$1 >>> 0) < (xlo$1 >>> 0)) | 0)) | 0);
      var k$2$1 = (((rhi$1 >>> 0) % 400) | 0);
      var quotLo$2$1 = ((0.002500000000000001 * ((4.294967296E9 * k$2$1) + (rlo$1 >>> 0.0))) | 0.0);
      var remLo$1 = ((rlo$1 - Math.imul(400, quotLo$2$1)) | 0);
      if ((year_$_hi < 0)) {
        var lo$2 = ((-remLo$1) | 0);
        var hi$1 = ((-((lo$2 !== 0) | 0)) | 0);
        var x$3_$_lo = lo$2;
        var x$3_$_hi = hi$1;
      } else {
        var x$3_$_lo = remLo$1;
        var x$3_$_hi = 0;
      }
      return ((x$3_$_lo | x$3_$_hi) === 0);
    }
  } else {
    return false;
  }
});
var $d_Ljava_time_Year$ = new $j_java$002elang$002e$002dObject.$TypeData().i($c_Ljava_time_Year$, "java.time.Year$", ({
  l9: 1
}));
export { $d_Ljava_time_Year$ as $d_Ljava_time_Year$ };
var $n_Ljava_time_Year$;
function $m_Ljava_time_Year$() {
  if ((!$n_Ljava_time_Year$)) {
    $n_Ljava_time_Year$ = new $c_Ljava_time_Year$();
  }
  return $n_Ljava_time_Year$;
}
export { $m_Ljava_time_Year$ as $m_Ljava_time_Year$ };
